import React from 'react';
import Image from '../../atoms/Image'
import Text from '../../atoms/Text'
import PortableText from '../../atoms/PortableText'

interface IProp {
  imgUrl: string
  imgAlt: string
  cardTitle: string
  subheading?: string
  cardContent: any
  className?: string
}

const IconCard: React.FC<IProp> = ({ imgUrl, imgAlt = '', cardTitle, subheading, cardContent, className = '', ...rest }) => (
  <article className={`border border-white-smoke shadow-lg p-6 ${className}`} {...rest}>
    {imgUrl ? <Image alt={imgAlt} src={imgUrl} className="h-16 w-16 object-contain mb-5" /> : ''}
    <Text type="H4" className="font-normal text-gray-800 mb-2">{cardTitle}</Text>
    {subheading ? <Text type="P" ptype='p-base' className="font-normal text-gray-800 mb-2">{subheading}</Text> : ''}
    {cardContent && (typeof cardContent === 'string' ? (<Text type="P" ptype="sm-light">{cardContent}</Text>) :
      <PortableText className="text-lg" content={cardContent} template={{
        normal: (props: any) => <Text type="P" ptype="p-base" className="text-dove-grey mb-2">{props.children}</Text>,
      }} />)
    }
  </article>
)

export default IconCard
